import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../Helper/Context";
import Selectslot from "./Selectslot";
import Directdebit from "./Directdebit";
import Debitcard from "./Debitcard";
import formatTime from "../Helper/formatTime";
import moment from "moment";
const Slots = ({ hidePopup, showLoginNotification }) => {
  const { mainState, slotsState, setShowLoader, setMainState } = useContext(ThemeContext);
  const [zoneSet, setZoneSet] = useState(new Set());
  // const [day, setDay] = useDay();

  const [selecteSlot, setSelectedSlot] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(false);
  const [course, setCourse] = useState([]);

  const handleSelectSlot = (e, slot) => {
    // setSlotsState({...slotsState,selectedSlot:null})
    if (mainState.isLoggedIn) {
      // console.log(slot);
      let selectedChild;
      mainState.children
        .filter((e) => e.selected === true)
        .map((child, index) => {
          selectedChild = child;
        });
      slot.selectedChild = selectedChild;
      if (slot.attendeesCount < slot.attendeesLimit) {
        setSelectedSlot(slot);
        setShowLoader(true);
        // console.log(slot);
      }
    } else {
      showLoginNotification();
    }
  };
  // console.log(selecteSlot)

  const handlePopup = (e) => {
    if (e.target.className.indexOf("perfectgym-popup") !== -1) {
      setSelectedSlot(false);
      setPaymentMethod(false);
    }
  };
  const closePopup = (e) => {
    setSelectedSlot(false);
    setPaymentMethod(false);
  };
  const handleBack = (e) => {
    setPaymentMethod(false);
  };
  const handlePaymentType = (e, type) => {
    setPaymentMethod(type);
  };

  const handleFetch = (courses) => {
    if (courses.length < 1) {
      setMainState({
        isLoggedIn: false,
        showVerification: false,
        section: "landing",
        slots: false,
      });
    }
    let day = "";
    let allClasses = {
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
      Saturday: [],
      Sunday: [],
    };

    // console.log(courses[0]);
    // const flattenC = courses.flatMap((c) => c.classes);
    // console.log(flattenC, "flatten");
    // flattenC.forEach((x) => console.log(x.clubId));
    courses.forEach((c, index) => {
      if (c.classes.length > 0) {
        let date = new Date(c.classes[0].startDate.split("T")[0]);
        switch (date.getDay()) {
          case 0:
            day = "Sunday";
            break;
          case 1:
            day = "Monday";
            break;
          case 2:
            day = "Tuesday";
            break;
          case 3:
            day = "Wednesday";
            break;
          case 4:
            day = "Thursday";
            break;
          case 5:
            day = "Friday";
            break;
          case 6:
            day = "Saturday";
            break;
        }
        let today = new Date();
        let nextSevenDays = moment(today.setDate(today.getDate() + 14)).format("YYYY-MM-DDT00:00:00+08:00");
        c.classes.forEach((cc, index) => {
          setZoneSet((prev) => prev.add(cc?.clubZoneId));
          cc.activityMemberLevel = c.activityMemberLevel;
          c.classes[index].enrollmentsCount = false;
          let vacancyBlocks = c.vacancyBlocks;
          if (c.vacancyBlocks.length > 0) {
            vacancyBlocks.forEach((vb, i) => {
              var compareDate = moment(c.classes[0].startDate);
              var startDate = moment(vb.startDate);
              var endDate = vb.endDate !== null ? moment(vb.endDate) : moment(nextSevenDays);
              // console.log(c.name, vb.startDate, c.classes[0].startDate, nextSevenDays, compareDate.isBetween(startDate, endDate));
              if (compareDate.isBetween(startDate, endDate)) {
                c.classes[index].enrollmentsCount = vb.enrollmentsCount;
              }
            });
          }
        });
        allClasses[day] = allClasses[day].concat(c.classes);
      }
    });

    let courseArr = [];
    for (let c in allClasses) {
      courseArr.push(allClasses[c]);
    }

    let daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    let today = new Date().getDay();
    // console.log("today", today);
    let sortedSlots = {};
    for (var i = 0; i < today; i++) {
      courseArr.push(courseArr.shift());
      daysOfWeek.push(daysOfWeek.shift());
    }

    for (var i = 0; i < courseArr.length; i++) {
      sortedSlots[daysOfWeek[i]] = courseArr[i];
      // console.log(i)
    }

    setCourse(sortedSlots);
    // console.log(course);
    setShowLoader(false);
  };

  useEffect(() => {
    // setShowLoader(false);
    let today = new Date();
    today.setDate(today.getDate());
    let tomorrow = moment(today.setDate(today.getDate() + 1)).format("YYYY-MM-DD");
    // tomorrow = moment(today.setDate(today.getDate() + 7)).format("YYYY-MM-DD");
    // let nextSevenDays = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + (today.getDate() + 7);
    let nextSevenDays = moment(today.setDate(today.getDate() + 7)).format("YYYY-MM-DD");
    //  nextSevenDays = moment(today.setDate(today.getDate() + 14)).format("YYYY-MM-DD");

    let fetchURL = mainState.fetchURL;
    let groupId = "";
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "CMSPreferredCulture=en-AU");

    // moment(date).format(' YYYY-MM-DD'),
    let element = document.getElementById("root");
    let className = element.getAttribute("data-class");
    let params = new URLSearchParams(window.location.search);
    let classNameQuery = params.get("Outcome");

    // console.log(classNameQuery);
    let bodyData = JSON.stringify({
      integrationcode: "PERFECTGYMAPI",
      endpointname: "GetGroupsClass",
      internalcall: "info.get.odata",
      useheadervariables: true,
      // "urlparams": "?$expand=classes&$select=name,startDate, id&$filter=contains(name,'(Warm Water 1) - Turtles') and startDate gt 2020-06-15T09%3a08%3a00%2b08%3a00 "+groupId,
      // $expand=ActivityMemberLevel,classes($expand=instructor)
      urlparams:
        "?$filter=contains(name,'" +
        classNameQuery +
        "')&$expand=ActivityMemberLevel,vacancyBlocks,classes($expand=instructor),classes($filter=startDate ge " +
        tomorrow +
        "  and endDate le " +
        nextSevenDays +
        " and isDeleted eq false)" +
        // ")" +
        groupId,
      // "urlparams": "?$filter=contains(name,'" + classNameQuery + "')&$expand=ActivityMemberLevel,classes($expand=instructor),classes($filter=startDate ge " + firstDayOfTheWeek + "  and endDate le " + lastDayOfTheWeek + ")" + groupId,
      body: "",
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: bodyData,
      redirect: "follow",
    };

    fetch(fetchURL, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.error) {
          alert(result.error.message);
        } else {
          handleFetch(result.value);
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  return (
    <>
      {/* {(slotsState.selectedSlot !== null && mainState.isLoggedIn) &&
            <Selectslot handleSelectSlot={handleSelectSlot} slotId={slotsState.selectedSlot} hidePopup={hidePopup} />
            } */}
      {selecteSlot && mainState.isLoggedIn && !paymentMethod && (
        <Selectslot slot={selecteSlot} hidePopup={handlePopup} paymentType={handlePaymentType} closePopup={closePopup} />
      )}
      {paymentMethod && paymentMethod === "directDebit" && mainState.isLoggedIn && (
        <Directdebit slot={selecteSlot} hidePopup={handlePopup} closePopup={closePopup} handleBack={handleBack} />
      )}
      {paymentMethod && paymentMethod === "debitCard" && mainState.isLoggedIn && (
        <Debitcard slot={selecteSlot} hidePopup={handlePopup} closePopup={closePopup} />
      )}

      <div className={`${mainState.isLoggedIn ? "slots active" : "slots"}`}>
        {course && (
          <>
            {Object.keys(course).map((keyName, i) => (
              <div key={i} className="slot-item">
                <div className="day">
                  {keyName}
                  <br></br>
                  <b>
                    {moment()
                      // .add(i + 8, "days")
                      .add(i + 1, "days")
                      .format("DD-MMM")}
                  </b>
                </div>
                <div className="slot-options">
                  {course[keyName].map((c, index) => {
                    // let vacancyBlocks = c.vacancyBlocks;
                    let attandanceCount = c.attendeesCount;

                    if (c.enrollmentsCount && c.enrollmentsCount > attandanceCount) {
                      // console.log(c);
                      attandanceCount = c.enrollmentsCount;
                    }
                    return (
                      <div key={index} className="slot-option-wrapper">
                        <div
                          onClick={(e) => handleSelectSlot(e, c)}
                          className={`${attandanceCount < c.attendeesLimit ? "slot-option active" : "slot-option"}`}
                          role="button"
                        >
                          {/* <div className="zone">Zone {c.clubZoneId}</div> */}
                          <div className="zone">Zone {[...zoneSet].indexOf(c.clubZoneId) + 1}</div>
                          <div className="time">
                            <div>{moment(c.startDate).format("h:mm a")} -</div>
                            <div>{moment(c.endDate).format("h:mm a")}</div>
                          </div>
                          <div className="spot">
                            {c.attendeesLimit - attandanceCount < 0 ? 0 : c.attendeesLimit - attandanceCount} Spot
                            {c.attendeesLimit - attandanceCount > 1 || c.attendeesLimit - attandanceCount < 1 ? "s" : ""}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default Slots;
